import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider, useLang } from "@/context/LangContext";
import { OrgProvider } from "@/context/OrgContext";
import { FacilityProvider } from "@/context/FacilityContext";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AppShell from "@/components/AppShell";
import Dashboard from "@/pages/Dashboard";
import ScopePage from "@/pages/ScopePage";
import Factors from "@/pages/Factors";
import Organization from "@/pages/Organization";
import Organizations from "@/pages/Organizations";
import Report from "@/pages/Report";
import Targets from "@/pages/Targets";
import Team from "@/pages/Team";
import ImportPage from "@/pages/ImportPage";
import Intensity from "@/pages/Intensity";
import Verification from "@/pages/Verification";
import Facilities from "@/pages/Facilities";
import Jobs from "@/pages/Jobs";
import Approvals from "@/pages/Approvals";
import Cbam from "@/pages/Cbam";
import CarbonTax from "@/pages/CarbonTax";
import Esrs from "@/pages/Esrs";
import Gri from "@/pages/Gri";
import Clients from "@/pages/Clients";
import Glossary from "@/pages/Glossary";
import AuthCallback from "@/pages/AuthCallback";
import ApiDocs from "@/pages/ApiDocs";
import Blog from "@/pages/Blog";
import Trends from "@/pages/Trends";

const Protected = () => {
  const { user, checked } = useAuth();
  if (!checked) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <OrgProvider>
      <FacilityProvider>
        <Outlet />
      </FacilityProvider>
    </OrgProvider>
  );
};

const Scope1Route = () => {
  const { t } = useLang();
  return <ScopePage scope={1} title={t("scope1")} description={t("scopeDescS1")} testPrefix="s1" />;
};
const Scope2Route = () => {
  const { t } = useLang();
  return <ScopePage scope={2} title={t("scope2")} description={t("scopeDescS2")} testPrefix="s2" />;
};
const Scope3Route = () => {
  const { t } = useLang();
  return <ScopePage scope={3} title={t("scope3")} description={t("scopeDescS3")} testPrefix="s3" />;
};

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/auth-callback" element={<AuthCallback />} />
              <Route path="/blog" element={<Blog />} />
              <Route element={<Protected />}>
                <Route path="/app" element={<AppShell />}>
                  <Route index element={<Dashboard />} />
                  <Route path="scope1" element={<Scope1Route />} />
                  <Route path="scope2" element={<Scope2Route />} />
                  <Route path="scope3" element={<Scope3Route />} />
                  <Route path="factors" element={<Factors />} />
                  <Route path="targets" element={<Targets />} />
                  <Route path="team" element={<Team />} />
                  <Route path="import" element={<ImportPage />} />
                  <Route path="jobs" element={<Jobs />} />
                  <Route path="approvals" element={<Approvals />} />
                  <Route path="facilities" element={<Facilities />} />
                  <Route path="intensity" element={<Intensity />} />
                  <Route path="verification" element={<Verification />} />
                  <Route path="cbam" element={<Cbam />} />
                  <Route path="carbon-tax" element={<CarbonTax />} />
                  <Route path="esrs" element={<Esrs />} />
                  <Route path="gri" element={<Gri />} />
                  <Route path="clients" element={<Clients />} />
                  <Route path="glossary" element={<Glossary />} />
                  <Route path="api" element={<ApiDocs />} />
                  <Route path="trends" element={<Trends />} />
                  <Route path="organizations" element={<Organizations />} />
                  <Route path="organization" element={<Organization />} />
                  <Route path="report" element={<Report />} />
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
